import axios from '@/utils/axios'

export const createSalesPromoFeeRecord = (payload ) => {
    return axios.post(`/sales_promo_fee_record`, payload)
}

export const createNoContactSalesPromoFeeRecord = (payload) => {
    return axios.post(`/sales_promo_fee_record_no_contact`, payload)
}

export const getSalesPromoFee = (payload ) => {
    return axios.get(`/sales_promo_fee_record`, {
        params: payload
    })
}

export const getCurrentPromoFee = (id) => {
    return axios.get(`/active_promo_fee/${id}`)
}

export const setActivcePromoFee = (id, data) => {
    return axios.put(`/set_active_promo_fee/${id}`, data)
}

export const updatePromoFee = (id, data) => {
    return axios.put(`/update_sales_promo_fee/${id}`, data)
}